<template>
	<v-layout fill-height column class="template-padding" >
		<div v-for="(item, itemIndex) in items" :key="itemIndex">
			<template v-if="item.type == 'banner' && itemIndex == 0">
				<div :class="outerContainer" class="container">
					<v-flex class="text-left">
						<div class="montserrat">
							<div class="font-weight-bold h4 mb-3" style="color: #f2482f"
								@focusout="editableData('banner', { element: 'heading' })" :contenteditable="editableContent"
								v-html="item.heading"
							>
							</div>
							<div class="font-weight-bold h4 mb-3" style="color: #131e56"
								@focusout="editableData('banner', { element: 'subtitle' })" :contenteditable="editableContent"
								v-html="item.subtitle"
							>
							</div>
						</div>
					</v-flex>

					<RowControls v-if="pageType == 'Canvas'" :rowIndex="itemIndex" />
				</div>
			</template>
			<template v-if="item.type == 'grids'">
				<Grid2 :item="item"
					:index="itemIndex"
					:styles="{
						text: 'body montserrat',
						image: {
							contain: true,
							wrapper: '',
							class: '',
							height: 'auto',
							width: 'auto',
							maxWidth: '100%',
							maxHeight: '',
							custom: {
								margin: '0 auto'
							}
						},
						heading1: {
							wrapper: '',
							classMobile: 'mb-5 montserrat font-weight-bold h5',
							classLarge: 'mb-5 montserrat font-weight-bold h5',
							after: '',
							guideWrapper: 'mb-5',
							guideClass: 'ml-5'
						},
						heading2: {
							wrapper: 'mt-5 mb-5 justify-center',
							classMobile: 'body montserrat grey--text',
							classLarge: 'body montserrat grey--text',
							after: '',
							guideWrapper: 'mt-5 mb-5',
							guideClass: 'ml-5'
						},
						textcard: {
							outlined: false,
							elevation: 0,
							card: 'bpp-card text-center pa-5 d-flex align-center justify-center',
							text: 'h5 montserrat-bold mb-5',
							subtitle: 'small-text poppins text-left mt-5'
						},
						imagecard: {
							doubleCard: false,
							elevation: 0,
							outlined: false,
							card: 'travel-english pa-5',
							imagePosition: 'bottom',
							image: {
								width: '',
								height: ''
							},
							text: 'text-left montserrat font-weight-bold body dark-blue',
							subtitle: ''
						},
						dialog: {
							elevation: 0,
							cardClass: 'py-5 px-5 mb-5',
							cardColor: '#F4F5F7',
							innerCard: '',
							dialogTitle: '',
							dialogName: 'montserrat body text-left mt-5 mr-3 responsive-text',
							textWrapper: 'montserrat body text-left responsive-text',
							custom: {
								text: '',
								textClass: 'mt-5'
							}
						}
					}"
				/>
			</template>
		</div>
		<ImageUploader />
		<span id="controls">
			<i class='bx bxs-x-square' id="close" @click="hideControls"></i>
			<i class='bx bxs-circle' id="selection-blue" @click="changeColor('blue')"></i>
			<i class='bx bxs-circle' id="selection-yellow" @click="changeColor('yellow')"></i>
			<i class='bx bxs-circle' id="selection-green" @click="changeColor('green')"></i>
			<i class='bx bxs-circle' id="selection-red" @click="changeColor('red')"></i>
			<i class='bx bxs-note' id="add-note" @click="openModal"></i>
			<i class='bx bxs-trash-alt' id="delete" @click="deleteHighlight"></i>
		</span>

		<v-dialog v-model="notes.modal" max-width="400" :persistent="false">
			<v-card class="pa-5 pt-10">
				<v-textarea outlined v-model="notes.data" placeholder="Add a note."></v-textarea>
				<v-row justify="center">
					<v-btn small dense color="primary" @click="saveNote">Save Note</v-btn>
				</v-row>
			</v-card>
		</v-dialog>
	</v-layout>
</template>

<script>
import RowControls from "@/components/RowControls.vue"
import ImageUploader from "@/components/ImageUploadModal.vue"
import { Grid2 } from "@/imports/elements.js"
import { highlights } from "@/mixins/highlights"

export default {
    props: ["items", "unitId"],
    mixins: [highlights],
    components: {
        RowControls, ImageUploader, Grid2
    },
    mounted () {
        // setTimeout(() => {
        //     this.getRangesFromDb()
        // }, 1500)
    },
    computed: {
        bannerTextSize () {
            return this.$vuetify.breakpoint.smAndDown ? "h4" : "h3"
        }
    }
}
</script>
<style scoped>
#controls {
	visibility: hidden;
	position: absolute;
	width: 190px;
	height: 35px;
	background-color: #444444;
	display: flex;
	align-items: center;
	justify-content: space-evenly;
	border-radius: 5px;
}

#controls::before{
  position: absolute;
  content: '';
  /* left: 50px; */
  top: 40px;
}

#controls i {
	cursor: pointer;
	font-size: 1.2em;
	text-shadow: 0 0 2px #000;
}

#selection-blue, mark.blue, .note-blue {
	color: #1c71f0;
}

#selection-red, mark.red, .note-red {
	color: #e23f26;
}

#selection-yellow, mark.yellow, .note-green {
	color: #fafa08;
}
#selection-green, mark.green, .note-yellow {
	color: green;
}

#controls #add-note {
	color: azure;
}
#controls #delete {
	color: red;
}
#controls #close {
	color: rgb(248, 162, 1);
}
mark {
	cursor: pointer;
}
</style>
